// JS側の fetch 部分
document.addEventListener('DOMContentLoaded', function() {
    const loaders = document.querySelectorAll('.js-async-loader');

    // オプション：ターゲットが画面に入る100px手前で読み込みを開始する設定
    const observerOptions = {
        root: null, // ビューポートを基準にする
        rootMargin: '100px 0px', // 少し早めに読み込みを開始して待ち時間を減らす
        threshold: 0 // 1ピクセルでも入ったら発火
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            // 要素が交差（画面内に入った）しているか確認
            if (entry.isIntersecting) {
                const el = entry.target;
                const tag = el.dataset.tag;
                const atts = el.dataset.atts || '{}';
                const blogId = el.dataset.blogId || '';

                // PHPから渡されたベースURLを取得
                const apiBase = jichikai_vars.rest_url;

                // URLを組み立てる
                let url = `${apiBase}jichica/v1/render-shortcode?tag=${tag}&atts=${encodeURIComponent(atts)}`;
                if (blogId) {
                    url += `&blog_id=${blogId}`;
                }

                // APIリクエスト実行
                fetch(url)
                    .then(res => res.json())
                    .then(data => {
                        if (data.html) {
                            el.innerHTML = data.html;
                            el.classList.add('is-loaded');
                        }
                    })
                    .catch(err => console.error('API Fetch Error:', err));

                // 一度読み込んだら、この要素の監視を解除する
                observer.unobserve(el);
            }
        });
    }, observerOptions);

    // 全てのローダー要素を監視対象に登録
    loaders.forEach(el => {
        observer.observe(el);
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const btnMedium = document.getElementById('btn-fs-medium');
    const btnLarge = document.getElementById('btn-fs-large');
    const root = document.documentElement;

    if (!btnMedium || !btnLarge) return;

    // --- 初期状態の反映 ---
    const savedSize = localStorage.getItem('jichica_font_size');

    // 1. まず「大」の状態をチェック（保存データ or classの有無）
    const isLarge = (savedSize === 'large' || root.classList.contains('is-font-large'));

    if (isLarge) {
        // 「大」を適用
        root.classList.add('is-font-large');
        root.style.setProperty('--font-scale', '1.14');
        btnLarge.classList.add('is-active');
        btnMedium.classList.remove('is-active');
    } else {
        // 「中」を適用（デフォルトはこちらに流れる）
        root.classList.remove('is-font-large');
        root.style.setProperty('--font-scale', '1');
        btnMedium.classList.add('is-active'); // ← これで遷移後も「中」が光ります
        btnLarge.classList.remove('is-active');
    }

    const setFontSize = (scale, isLargeVal) => {
        root.style.setProperty('--font-scale', scale);
        root.classList.toggle('is-font-large', isLargeVal);
        btnLarge.classList.toggle('is-active', isLargeVal);
        btnMedium.classList.toggle('is-active', !isLargeVal);
        localStorage.setItem('jichica_font_size', isLargeVal ? 'large' : 'medium');
    };

    btnMedium.onclick = () => setFontSize('1', false);
    btnLarge.onclick = () => setFontSize('1.14', true);
});

document.addEventListener('DOMContentLoaded', function () {
    // ★追加：ページ内に回覧板のモーダルトリガーが存在しない場合は処理を終了（HTMLを生成しない）
    if (!document.querySelector('.jcc-kairan-modal-trigger')) return;
    const overlay = document.createElement('div');
    overlay.className = 'jcc-kairan-modal-overlay';
    overlay.innerHTML = `
        <div class="jcc-kairan-modal-content">
            <button class="jcc-kairan-modal-close" aria-label="閉じる">✕</button>
            <button class="jcc-kairan-modal-btn jcc-kairan-modal-prev" aria-label="前へ">❮</button>
            <img src="" alt="拡大画像">
            <button class="jcc-kairan-modal-btn jcc-kairan-modal-next" aria-label="次へ">❯</button>
        </div>
    `;
    document.body.appendChild(overlay);

    const modalContent = overlay.querySelector('.jcc-kairan-modal-content');
    const modalImg = overlay.querySelector('img');
    const btnClose = overlay.querySelector('.jcc-kairan-modal-close');
    const btnPrev = overlay.querySelector('.jcc-kairan-modal-prev');
    const btnNext = overlay.querySelector('.jcc-kairan-modal-next');

    let currentGallery = [];
    let currentIndex = 0;

    // --- スワイプ / フリック計測用変数 ---
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    const threshold = 40; // 40px以上動かしたらページ切り替え

    // 画像ギャラリー起動
    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('.jcc-kairan-modal-trigger');
        if (!trigger) return;

        e.preventDefault();

        const grid = trigger.closest('.jcc-kairan-front-grid');
        if (!grid) return;

        const triggers = Array.from(grid.querySelectorAll('.jcc-kairan-modal-trigger'));
        currentGallery = triggers.map(el => el.getAttribute('data-full-src'));
        currentIndex = triggers.indexOf(trigger);

        updateModalImage();
        overlay.classList.add('active');
    });

    function updateModalImage() {
        if (currentGallery.length === 0) return;
        modalImg.style.transform = 'translateX(0)';
        modalImg.src = currentGallery[currentIndex];

        btnPrev.style.display = currentGallery.length > 1 ? 'flex' : 'none';
        btnNext.style.display = currentGallery.length > 1 ? 'flex' : 'none';
    }

    function showNext() {
        currentIndex = (currentIndex + 1) % currentGallery.length;
        updateModalImage();
    }

    function showPrev() {
        currentIndex = (currentIndex - 1 + currentGallery.length) % currentGallery.length;
        updateModalImage();
    }

    function closeModal() {
        overlay.classList.remove('active');
        modalImg.src = '';
    }

    // --- タッチ＆ドラッグ（フリック・スワイプ）制御 ---
    function handleTouchStart(e) {
        if (currentGallery.length <= 1) return;
        isDragging = true;
        startX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
        currentX = startX;
        modalImg.style.transition = 'none';
    }

    function handleTouchMove(e) {
        if (!isDragging) return;
        currentX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
        const diffX = currentX - startX;

        // 指やカーソルの動きに合わせてリアルタイムに画像を追従移動
        modalImg.style.transform = `translateX(${diffX}px)`;
    }

    function handleTouchEnd() {
        if (!isDragging) return;
        isDragging = false;
        modalImg.style.transition = 'transform 0.15s ease-out';

        const diffX = currentX - startX;

        if (diffX < -threshold) {
            showNext(); // 左スワイプで次へ
        } else if (diffX > threshold) {
            showPrev(); // 右スワイプで前へ
        } else {
            modalImg.style.transform = 'translateX(0)'; // 距離が足りない場合は元に戻す
        }
    }

    // イベント登録（タッチ & マウスドラッグ対応）
    modalContent.addEventListener('touchstart', handleTouchStart, { passive: true });
    modalContent.addEventListener('touchmove', handleTouchMove, { passive: true });
    modalContent.addEventListener('touchend', handleTouchEnd);

    modalContent.addEventListener('mousedown', handleTouchStart);
    window.addEventListener('mousemove', handleTouchMove);
    window.addEventListener('mouseup', handleTouchEnd);

    // ボタン・キーボード操作
    btnNext.addEventListener('click', function (e) { e.stopPropagation(); showNext(); });
    btnPrev.addEventListener('click', function (e) { e.stopPropagation(); showPrev(); });
    btnClose.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal();
    });

    document.addEventListener('keydown', function (e) {
        if (!overlay.classList.contains('active')) return;
        if (e.key === 'Escape') closeModal();
        if (e.key === 'ArrowLeft') showPrev();
        if (e.key === 'ArrowRight') showNext();
    });
});

// 回覧板ファイル（Office文書等）のタップ時に確認アラートを表示
document.addEventListener('click', function (e) {
    // 回覧板カード内の「画像以外（モーダル起動用クラスを持たない）ダウンロードリンク」を判定
    const link = e.target.closest('.jcc-kairan-front-card a:not(.jcc-kairan-modal-trigger)');
    if (!link) return;

    // ファイル名を取得（無ければデフォルト名）
    const fileName = link.innerText.trim() || 'ファイル';

    // 確認ダイアログを表示
    const isConfirmed = window.confirm(`「${fileName}」をダウンロードしますか？`);

    if (!isConfirmed) {
        e.preventDefault(); // キャンセルされた場合はダウンロードを停止
    }
});
